
const digest = 'be9cd9e715a1b13ea1e5bda2588886dfaea69586bbc3ea213c7793bbfc73092d';
const classes = {"wrapper":"_wrapper_172ob_1","title":"_title_172ob_8","button":"_button_172ob_19","warning":"_warning_172ob_22","inline":"_inline_172ob_33","error":"_error_172ob_36"};
const css = `._wrapper_172ob_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
}
._wrapper_172ob_1 b {
  font-weight: 600;
}
._wrapper_172ob_1 ._title_172ob_8 {
  font-weight: 600;
  font-size: 16px;
}
._wrapper_172ob_1 ol {
  margin: 20px 0;
  padding-left: 18px;
}
._wrapper_172ob_1 ol li {
  margin-bottom: 10px;
}
._wrapper_172ob_1 ._button_172ob_19 {
  width: fit-content;
}
._wrapper_172ob_1 ._warning_172ob_22 {
  margin: 20px 0;
}
._wrapper_172ob_1 ul {
  padding-left: 20px;
  margin: 10px 0;
}
._wrapper_172ob_1 img {
  height: 200px;
  margin: 10px 0;
}
._wrapper_172ob_1 ._inline_172ob_33 {
  display: inline-block;
}
._wrapper_172ob_1 ._error_172ob_36 {
  color: #ff0000;
  margin: 10px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  